/**
 * Locale-aware formatting helpers. The active app language drives the locale so
 * dates read naturally in ca/es. Code identifiers stay English (CLAUDE.md).
 */

import type { AppLanguage } from '@obrava/shared';

const LOCALE: Record<AppLanguage, string> = {
  ca: 'ca-ES',
  es: 'es-ES',
  en: 'en-GB',
};

/** Format an ISO timestamp as a short date, or `null` when absent. */
export function formatDate(
  iso: string | null | undefined,
  language: AppLanguage,
): string | null {
  if (!iso) return null;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  return new Intl.DateTimeFormat(LOCALE[language], {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  }).format(d);
}

/** Format an ISO timestamp as a short date + time (day, month, hour:minute), or `null`. */
export function formatDateTime(
  iso: string | null | undefined,
  language: AppLanguage,
): string | null {
  if (!iso) return null;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  return new Intl.DateTimeFormat(LOCALE[language], {
    day: '2-digit',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit',
  }).format(d);
}
